import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { RadiusType } from '../result-rich-text-block/result-rich-text-block.component';

@Component({
  selector: 'result-rich-text-preformatted',
  templateUrl: './result-rich-text-preformatted.component.html',
  styleUrls: ['./result-rich-text-preformatted.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextPreformattedComponent {
  @Input() model: Results.RichTextPreformatted;
  @Input() highlights: Array<string>;
  @Input() borderRadius: RadiusType;
  @Output() invoke = new EventEmitter<Commands.Command>();
}
